<template lang="pug">
span
  span(@click="handleClick")
    slot(name="activator")
  v-dialog.d-inline(v-model="isModalVisible" persistent max-width="480")
    v-card(data-cy="add-tag-modal")
      title-bar(dark) {{ dialogTitle }}
      v-card-text
        tags-picker(
          v-model="selectedTags"
          :disabled="false"
          :tags-list="tagsList"
          @update:searchInput="findTags"
          @save:tag="createTag"
        )
        v-checkbox(
          v-model='removeExistingTags'
          label='Remove existing tags?'
        )
      v-card-actions
        v-spacer
        v-btn(flat @click="cancel") Cancel
        v-btn.primary(@click="save" data-cy="save-tag-btn") Save
</template>

<script>
import { mapActions } from 'vuex';
import TitleBar from '@/Core/components/TitleBar';
import Modal from '@/Core/mixins/modal';
import TagsPicker from '@/Core/components/TagsPicker';
import maxContacts from '@/Contacts/config/bulk-action-limits';
import { createTagsString } from '../../utilities';

export default {
  components: {
    TitleBar,
    TagsPicker,
  },
  mixins: [Modal],
  props: {
    tagsList: Array,
    selectedIds: {
      type: Array,
    },
    selectedContacts: {
      type: Array,
      default: [],
    },
    title: {
      type: String,
      default: 'add',
    },
    patchContacts: {
      type: Function,
    },
    contactUpdateActionPayload: {
      type: Function,
    },
    hasBulkActionFF: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      removeExistingTags: false,
      selectedTags: [],
    };
  },
  computed: {
    dialogTitle() {
      const amount = this.selectedIds.length === 1 ? 'Contact' : 'Contacts';
      if (this.selectedIds.length === 1) {
        return `${this.title} for ${amount}`;
      }
      return `${this.title} for ${this.selectedIds.length} ${amount}`;
    },
  },
  methods: {
    ...mapActions('contact', ['findTags', 'createTag']),
    async handleClick() {
      if (this.selectedIds && this.selectedIds.length <= maxContacts.tags) {
        await this.findTags();
        this.modal_open();
      } else {
        this.$emit('too-many-contacts', 'tags');
      }
    },
    async save() {
      let payload;
      if(this.hasBulkActionFF) {
        const action = this.contactUpdateActionPayload({
          tags: createTagsString(this.selectedTags),
          remove_existing_tags: this.removeExistingTags,
        });
        payload = {
          action,
          selected: this.selectedIds,
        };
      } else {
        payload = {
          tags: this.selectedTags,
          selected: this.selectedContacts,
          removeExistingTags: this.removeExistingTags,
        };
      }
      this.modal_close();
      await this.patchContacts(payload);
      this.$emit('deselect-all');
      this.$emit('contact-updated');
      this.cancel();
    },
    cancel() {
      this.modal_close();
      this.selectedTags = [];
      this.removeExistingTags = false;
    },
  },
};
</script>
